<template>
  <v-container
    fluid
    class="firma-container"
  >
    <v-row>
      <v-col>
        <div class="search-blog-category">
            <a
              v-for="(category, i) in categories[query.index]"
              :key="i"
              :class="`search-blog-category--link ${query.category === category && 'is-selected'}`"
              @click="updateQuery({ category })"
            >{{ category }}</a>
        </div>
        <div class="search-blog-posts" >
            <ul class="search-blog-posts--list is-selected pa-0">
              <li
              v-for="(post, i) in hits"
              :key="i"
              class="search-blog-posts--list--item"
              >
                  <p class="search-blog-posts--list--item--title">
                      {{ post.title }}
                  </p>
                  <p class="search-blog-posts--list--item--description">
                      {{ post.excerpt }}
                  </p>
                  <div>
                    <a :href="post.url" class="link-more" target="_parent">
                      {{ $t('readMore') }}
                    </a>
                  </div>
              </li>
            </ul>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'Web',
  props: {
    categories: {
      type: Object,
      required: true,
    },
    hits: {
      type: Array,
      required: true,
    },
    query: {
      type: Object,
      required: true,
    },
    updateQuery: {
      type: Function,
      required: true,
    }
  },
}
</script>